module.exports = __webpack_public_path__ + "img/logoDP.f60d141e.png";